import classNames from 'classnames';
import { type Dispatch, type SetStateAction, useMemo } from 'react';

export enum MarkdownTextareaMode {
  EDITOR,
  PREVIEW,
}

export enum MarkdownTextareaModePosition {
  TOP,
  BOTTOM,
}

interface MarkdownSwitcherProps {
  activeMode: MarkdownTextareaMode;
  className?: string;
  desiredMode: MarkdownTextareaMode;
  disabled?: boolean;
  hidden?: boolean;
  position: MarkdownTextareaModePosition;
  onClick: Dispatch<SetStateAction<MarkdownTextareaMode>>;
}

export const MarkdownSwitcher = ({
  activeMode,
  className = '',
  desiredMode,
  disabled,
  hidden,
  position,
  onClick,
}: MarkdownSwitcherProps) => {
  const title = useMemo(() => {
    switch (desiredMode) {
      case MarkdownTextareaMode.EDITOR:
        return 'Markdown editor';
      case MarkdownTextareaMode.PREVIEW:
        return 'Preview';
      default:
        return '';
    }
  }, [desiredMode]);

  return (
    <>
      {!hidden && (
        <div
          className={classNames(
            'cursor-pointer',
            'select-none',
            'border',
            'px-2',
            'py-1',
            'text-xs',
            {
              'hover:bg-gray-100': activeMode !== desiredMode,
              'bg-blue-50 text-blue-6': activeMode === desiredMode,
              'border-b-0': position === MarkdownTextareaModePosition.TOP,
              'border-t-0': position === MarkdownTextareaModePosition.BOTTOM,
            },
            className,
          )}
          onClick={() => {
            if (!disabled) {
              onClick(desiredMode);
            }
          }}
        >
          {title}
        </div>
      )}
    </>
  );
};
